import React, { useEffect, useState } from "react";
import { NavLink, Link, Navigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { useLocation } from "react-router-dom";
const cookies = new Cookies();

export default function MenuItem(props) {
  const { name, subMenus, iconClassName, onClick, to, exact, preventID } =
    props;
  const [activeSubList, setActiveSubList] = useState(null);
  const [expand, setExpand] = useState(false);
  const setactiveCalssColor = (index) => {
    setActiveSubList(index);
  };
  const location = useLocation();
  const showMessage = (id) => {
    if (cookies.get("role_id") == id) {
      alert("ليس لديك صلاحية للوصول لهذا الموقع");
    }
  };

  // const Protected = ({ todirection, children }) => {
  //   if (cookies.get("role_id") != preventID) {
  //     return <Navigate to={todirection} replace />;
  //   }
  //   return children;
  // };

  const getNameOfMenu = (name) => {
    let name2 = name.split("");
    if (name2.length > 25) {
    }
  };

  useEffect(() => {
    if (subMenus && subMenus.length > 0) {
      subMenus.map((data) => {
        if (data.to == location.pathname) {
          setExpand(true);
        }
      });
    }
  }, [location]);
  if (
    preventID.length > 0 &&
    !preventID.includes(parseInt(cookies.get("role_id")))
  )
    return (
      <li onClick={props.onClick}>
        <Link
          exact="true"
          to={to}
          onClick={() => {
            setExpand((e) => !e);
          }}
          className={`menu-item ${
            location.pathname == to || expand ? "active" : ""
          }`}
        >
          <div className="menu-icon">
            <i className={iconClassName}></i>
          </div>
          <span className="listSideMenuName">{name}</span>
        </Link>
        {subMenus && subMenus.length > 0 ? (
          <ul className={`sub-menu ${expand ? "active" : ""}`}>
            {subMenus.map((menu, index) =>
              menu.preventID && menu.preventID.length > 0 ? (
                !menu.preventID.includes(parseInt(cookies.get("role_id"))) ? (
                  <li key={index}>
                    <Link
                      exact="true"
                      className={`submenulist  ${
                        location.pathname == menu.to ? "active" : ""
                      }`}
                      to={menu.to}
                      onClick={() => {
                        setactiveCalssColor.bind(this, index);
                      }}
                    >
                      {menu.name}
                    </Link>
                  </li>
                ) : null
              ) : null
            )}
          </ul>
        ) : null}
      </li>
    );
  else return null;
}
